import React from 'react';
import { Text } from '../../components/text';
export const ItemTitle = ({ section, item }) => {
    if (section.show?.title === false) {
        return null;
    }
    return (React.createElement(Text, { align: section.title.align, color: section.title.color, fontFamily: section.title.fontFamily, fontSize: section.title.fontSize, fontStyle: section.title.fontStyle, fontWeight: section.title.fontWeight || undefined, lineHeight: section.title.lineHeight, textDecoration: section.title.textDecoration, padding: "0px" }, item.title));
};
//# sourceMappingURL=item-title.js.map